import React from 'react';
import { Box, Button, Grid, InputAdornment, Menu, MenuItem, OutlinedInput, Pagination, Typography } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { IconSearch } from '@tabler/icons-react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { AgencyCard } from './AgencyCard';

interface AgenciesGridProps {
    data: Record<string, any>;
    rowsPerPage: number | null;
    currentPage: number;
    setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

export const AgenciesGrid: React.FC<AgenciesGridProps> = ({ data, currentPage, rowsPerPage, setRowsPerPage, setCurrentPage }) => {
    const [users, setUsers] = React.useState(data);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [search, setSearch] = React.useState('');
    const { content, totalPages } = users;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (totalItems?: number) => {
        if (totalItems) {
            setRowsPerPage(totalItems);
            setCurrentPage(1); // Reset to first page when rows per page change
        }
        setAnchorEl(null);
    };

    console.log('data1: ', data);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newString = event.target.value;
        setSearch(newString);

        if (newString) {
            const filteredUsers = data.filter((user) =>
                Object.values(user).some((val) => String(val).toLowerCase().includes(newString.toLowerCase()))
            );
            setUsers(filteredUsers);
        } else {
            setUsers(data);
        }
    };

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    const usersResult = content?.map((user, index) => (
        <Grid key={index} item xs={12} sm={6} lg={4} xl={3}>
            <AgencyCard
                about="hi"
                avatar={user.name}
                contact={user.phoneNumber}
                email={user.emailAddress}
                address={user.address}
                name={user.name}
                role={user.name}
                id={user.id}
            />
        </Grid>
    ));

    return (
        <Box>
            <MainCard>
                <Grid container direction="row" spacing={gridSpacing}>
                    {usersResult}
                </Grid>
                <Box className={`flex justify-${totalPages > 1 ? 'between' : 'end'} items-center mt-4`}>
                    {totalPages > 1 && <Pagination count={totalPages} color="primary" page={currentPage} onChange={handlePageChange} />}
                    <Button
                        variant="text"
                        size="large"
                        sx={{ color: 'grey.900' }}
                        color="inherit"
                        endIcon={<ExpandMoreRoundedIcon />}
                        onClick={handleClick}
                    >
                        {rowsPerPage} rows
                    </Button>
                    {anchorEl && (
                        <Menu
                            id="menu-user-card-style1"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={() => handleClose()}
                            variant="selectedMenu"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                        >
                            <MenuItem onClick={() => handleClose(10)}>10 Rows</MenuItem>
                            <MenuItem onClick={() => handleClose(20)}>20 Rows</MenuItem>
                            <MenuItem onClick={() => handleClose(30)}>30 Rows</MenuItem>
                        </Menu>
                    )}
                </Box>
            </MainCard>
        </Box>
    );
};
